import {
  EventEntryInput,
  EventStatus,
  EventType,
  Region,
  RoadwayDirection,
  TrafficControlType,
  TrafficImpact,
  TrafficImpactType,
} from "../../reducers/states/event-management";

export const createMockEvent = ({
  name = "mock event",
  type = EventType.Contract,
  status = EventStatus.Active,
  stateRoute = "2",
  startMilepost = 0,
  endMilepost = 10,
  direction = RoadwayDirection.Both_Directions,
  commonName = "commonName",
  contractNumber = "1",
  projectNotes = "Misc text for notes",
}: {
  name?: string;
  type?: EventType;
  status?: EventStatus;
  stateRoute?: string;
  startMilepost?: number;
  endMilepost?: number;
  direction?: RoadwayDirection;
  commonName?: string;
  contractNumber?: string;
  projectNotes?: string;
}): EventEntryInput => {
  let d = (new Date((new Date()).setHours(0,0,0,0)));
  let today = d.toISOString();
  let oneWeekFromNow = (new Date(d.setDate(d.getDate() + 7))).toISOString();
  let twoWeeksFromNow = (new Date(d.setDate(d.getDate() + 7))).toISOString();
  let threeWeeksFromNow = (new Date(d.setDate(d.getDate() + 7))).toISOString();
  let thirtyDaysFromNow  = (new Date(d.setDate(d.getDate() + 9))).toISOString();
  
  return {
    id: `TESTID-${name}-${type}-${status}`, // todo: real ID later
    contacts: [
      {
        name: "Ryan Hilton",
        email: "ryan.hilton@wsdot.wa.gov",
        priPhone: "555-555-1212",
        title: "Manager",
      },
      {
        name: "Jeremy Cavner",
        email: "cavnerj@wsdot.wa.gov",
        priPhone: "555-555-1212",
        title: "developer",
      },
    ],
    contractNumber,
    counties: [],
    createdBy: "jcavner", // todo: actual user
    createdDate: new Date().toISOString(),
    endDate: thirtyDaysFromNow,
    startDate: today,
    eventName: name,
    geometry: { type: "Point", coordinates: [-122.33164868772502, 47.59513705616189]},
    locations: [
      {
        endMilepost: endMilepost,
        direction: direction,
        startMilepost: startMilepost,
        stateRoute: stateRoute,
        commonName: commonName,
      },
      {
        endMilepost: endMilepost,
        direction: direction,
        startMilepost: startMilepost,
        stateRoute: stateRoute,
        commonName: commonName,
      },
    ],
    isMajorEvent: true,
    projectNotes: projectNotes,
    region: Region.Northwest,
    trafficImpacts: [
      {
        stateRoute: "2",
        commonName: "Hwy 2",
        direction: RoadwayDirection.Westbound,
        startMilepost: 1,
        endMilepost: 10,
        type: TrafficImpactType.SingleLane,
        priority: "mock pri",
        status: EventStatus.Active,
        startDate: today,
        startTime: "22:00",
        endDate: oneWeekFromNow,
        endTime: "05:00",
        isContinuous: true,
        contingencyStartDate: twoWeeksFromNow,
        contingencyEndDate: threeWeeksFromNow,
        workDescription: "Misc text to describe work",
        trafficControlRequired: TrafficControlType.ShortTermRampClosures,
        comments: "Misc text for mock comments",
      } as TrafficImpact,
      {
        stateRoute: "90",
        commonName: "I-90",
        direction: RoadwayDirection.Eastbound,
        startMilepost: 11,
        endMilepost: 20,
        type: TrafficImpactType.TwoLeftLanes,
        priority: "mock pri",
        status: EventStatus.Active,
        startDate: today,
        startTime: "02:00",
        endDate: oneWeekFromNow,
        endTime: "09:00",
        isContinuous: false,
        workDays: ["Sat", "Sun"],
        contingencyStartDate: twoWeeksFromNow,
        contingencyEndDate: threeWeeksFromNow,
        workDescription: "Misc text to describe work",
        trafficControlRequired: TrafficControlType.ShortTermRampClosures,
        comments: "Misc text for mock comments",
      } as TrafficImpact,
      {
        stateRoute: "5",
        commonName: "I-5",
        direction: RoadwayDirection.Both_Directions,
        startMilepost: 160,
        endMilepost: 167,
        type: TrafficImpactType.DoubleLaneClosure,
        priority: "mock pri",
        status: EventStatus.Active,
        startDate: today,
        startTime: "20:00",
        endDate: oneWeekFromNow,
        endTime: "07:00",
        workDays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        workDescription: "Misc text to describe work",
        trafficControlRequired: TrafficControlType.ShortTermRampClosures,
        comments: "Misc text for mock comments",
      } as TrafficImpact,
    ],
    status,
    type,
    updateLog: [],
  };
};
